export default "__VITE_ASSET__1d8cfa93__"